import { Module } from 'vuex'
import Carrier from '@/modules/shipping/model/Carrier'
import Rate from '@/modules/shipping/model/Rate'
import Region from '@/modules/shipping/model/Region'
import RegionDetailMode from '@/modules/shipping/model/RegionDetailMode'
import RateDetailMode from '@/modules/shipping/model/RateDetailMode'
import { RootState } from '@/store/types'
import mutations from '@/modules/shipping/store/mutations'
import actions from '@/modules/shipping/store/actions'
import getters from '@/modules/shipping/store/getters'

export interface ShippingState {
    carriers: Carrier[]
    rates: Rate[]
    regions: Region[],
    currentRate: Rate
    carrierListFullyLoaded: boolean
    currentRegion: Region,
    regionDetailMode: RegionDetailMode,
    loadingRates: boolean
    deletingRate: boolean,
    rateToDelete: Rate,
    rateDetailMode: RateDetailMode,

    // Propiedades para la edición del transportista
    currentCarrier: Carrier,
}

const vuexModule: Module<ShippingState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    getters,
    state: {
        carriers: [],
        rates: [],
        regions: [],
        currentRate: new Rate(),
        currentRegion: new Region(),
        carrierListFullyLoaded: false,
        regionDetailMode: RegionDetailMode.None,
        loadingRates: false,
        deletingRate: false,
        rateToDelete: new Rate(),
        rateDetailMode: RateDetailMode.None,
        currentCarrier: new Carrier(''),
    },
}

export default vuexModule
